import React, { useEffect } from 'react';
import { useStore } from '../../context/StoreContext';
import BrandThemeProvider from '../../theme/BrandThemeProvider';
import { useCachedBrandColors } from '../../theme/brandColorCache';
import { buildBrandPalette } from '../../theme/buildBrandPalette';

const setThemeColorMeta = (color) => {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return undefined;
  const previous = meta.getAttribute('content');
  meta.setAttribute('content', color);
  return () => meta.setAttribute('content', previous);
};

/**
 * Themes the customer storefront with the store's brand colours. The API only
 * returns colours for stores whose plan allows custom branding.
 */
const CustomerBrandTheme = ({ children }) => {
  const { storeId, storeSlug, subdomainMode, storeOverview, notFound } = useStore();
  const cacheKey = subdomainMode ? (storeSlug && `slug:${storeSlug}`) : storeId;
  const colors = useCachedBrandColors(
    cacheKey,
    storeOverview?.brandColors,
    Boolean(storeOverview) || notFound,
  );
  const themeColor = buildBrandPalette(colors).primary;

  useEffect(() => setThemeColorMeta(themeColor), [themeColor]);

  return (
    <BrandThemeProvider colors={colors} scope="store">
      {children}
    </BrandThemeProvider>
  );
};

export default CustomerBrandTheme;
